import './style.css'
import * as THREE from 'three'
//import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { PointerLockControls } from 'three/examples/jsm/controls/PointerLockControls'
import { Water } from 'three/examples/jsm/objects/Water'
import * as dat from 'dat.gui'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
//import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module'

import { Group, ObjectSpaceNormalMap } from 'three'
import { PositionalAudioHelper } from 'three/examples/jsm/helpers/PositionalAudioHelper'
import { gsap } from 'gsap'

const startBtn = document.getElementById('startButton')
const menu = document.getElementById('menuPanel')

// Loading Manager
const loadingBarElement = document.querySelector('.loading-bar')
const loadingText = document.getElementById('.blink_me')



const loadingManager = new THREE.LoadingManager(
    // Loaded
    () => {
        window.setTimeout(() => {

            
            gsap.to(overlayMaterial.uniforms.uAlpha, {
                duration: 3,
                value: 0,
                delay: 1
                
            })
            
            loadingBarElement.classList.add('ended')
            loadingBarElement.style.transform = ''
            loadingText.classList.add('ended')
            loadingText.style.display = "none";
           
            
        }, )
    },
    // Progress
    (itemUrl, itemsLoaded, itemsTotal) => {
        
        const progressRatio = itemsLoaded / itemsTotal
        loadingBarElement.style.transform = `scaleX(${progressRatio})`;
        
        
    }
    
)


/**
 * Base
 */
// Debug
const gui = new dat.GUI()

gui.hide()



/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}
// Canvas
const canvas = document.querySelector('canvas.webgl')

let velocity = new THREE.Vector3()
let direction = new THREE.Vector3()

let moveForward = false
let moveBack = false
let moveRight = false
let moveLeft = false

// Scene
const scene = new THREE.Scene()
scene.background = new THREE.Color('#abc7dd')
scene.fog = new THREE.FogExp2('#abc7dd', 0.04, 0.1)


// const axesHelper = new THREE.AxesHelper( 5 );
// scene.add( axesHelper );
/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})

renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap // default THREE.PCFShadowMap

// Overlay Loading
const overlayGeometry = new THREE.PlaneGeometry(2, 2, 1, 1)
const overlayMaterial = new THREE.ShaderMaterial({
    transparent: true,
    uniforms: {
        uAlpha: { value: 1 }
    },
    vertexShader: `
        void main()
        {
            gl_Position = vec4(position, 1.0);
        }
    `,
    fragmentShader: `
    uniform float uAlpha;
        void main()
        {
            gl_FragColor = vec4(0.0, 0.0, 0.0, uAlpha);
        }
    `
})

const overlay = new THREE.Mesh(overlayGeometry, overlayMaterial)
scene.add(overlay)

// Video
// Mesh
// var video = document.getElementById('video')
// // /video.play()
// const texture = new THREE.VideoTexture(video)
// const material = new THREE.MeshLambertMaterial({
//     color: 0xffffff,
//     map: texture
// })
// const geometry = new THREE.PlaneGeometry(6, 6, 10, 10)
// const videoplane = new THREE.Mesh(geometry, material)
video.muted = true // intentionally muted to prevent positional audio from playing in jumbled manner

// videoplane.position.set(1, 2, 12)
// videoplane.rotation.y = -3.9
// scene.add(videoplane)
// gui
//   .add(videoplane.position, 'y')
//   .min(-5)
//   .max(5)
//   .step(0.01)
//   .name('Vid-elevation')
// gui.add(videoplane.rotation, 'y').min(-5).max(5).step(0.01).name('Vid-rotY')
// gui.add(videoplane.position, 'x').min(-40).max(40).step(0.01).name('Vid-X')
// gui.add(videoplane.position, 'z').min(-40).max(40).step(0.01).name('Vid-Z')

// Lights lighting Venice 1
//const pointLight = new THREE.PointLight(0xffffff, 0.5)
//pointLight.position.x = -10
//pointLight.position.y = 4
//pointLight.position.z = 4.8
//scene.add(pointLight)



/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const matcapTexture = textureLoader.load('textures/matcaps/3.png')
const matcapTexture2 = textureLoader.load('textures/matcaps/pngegg.png')
const matcapTexture3 = textureLoader.load('textures/matcaps/8.png')
const particleTexture1 = textureLoader.load('img/cell wobble inv.png')
const particleTexture2 = textureLoader.load('img/longcell.jpg')

//Fonts

// Particles 1
const particlesGeometry1 = new THREE.BufferGeometry()
const count1 = 50000

const positions1 = new Float32Array(count1 * 3) // Multiply by 3 because each position is composed of 3 values (x, y, z)

for (
    let i = 0;
    i < count1 * 3;
    i++ // Multiply by 3 for same reason
) {
    positions1[i] = (Math.random() - 0.5) * 10 // Math.random() - 0.5 to have a random value between -0.5 and +0.5
}

particlesGeometry1.setAttribute(
    'position',
    new THREE.BufferAttribute(positions1, 3)
) // Create the Three.js BufferAttribute and specify that each information is composed of 3 values

//particlesMaterial.map = particleTexture

//particle material
const particlesMaterial1 = new THREE.PointsMaterial()
particlesMaterial1.size = 0.6
particlesMaterial1.sizeAttenuation = true
//particlesMaterial.color = new THREE.Color('#ff88cc')
//particlesMaterial.map = particleTexture
particlesMaterial1.transparent = true
particlesMaterial1.alphaMap = particleTexture1
//particlesMaterial.alphaTest = 0.001
particlesMaterial1.depthWrite = false

const particles1 = new THREE.Points(particlesGeometry1, particlesMaterial1)
scene.add(particles1)
particles1.position.set(-3, 1, -15)
particles1.scale.set(20, 20, 20)


// particle 2
const particlesGeometry2 = new THREE.BufferGeometry()
const count2 = 5000

const positions2 = new Float32Array(count2 * 3) // Multiply by 3 because each position is composed of 3 values (x, y, z)
const rotation2 = new Float32Array(count2 * 3)
const colors2 = new Float32Array(count2 * 3)

for(let i = 0; i < count2 * 3; i++) // Multiply by 3 for same reason
{
   
  positions2[i] = (Math.random() - 0.5) * 10 // Math.random() - 0.5 to have a random value between -0.5 and +0.5
  colors2[i] = Math.random(); 
  rotation2[i] = (Math.random() - 0.5) * 10;
}

particlesGeometry2.setAttribute('color', new THREE.BufferAttribute(colors2, 3)) 
particlesGeometry2.setAttribute('position', new THREE.BufferAttribute(positions2, 3)) // Create the Three.js BufferAttribute and specify that each information is composed of 3 values
particlesGeometry2.setAttribute('rotation', new THREE.BufferAttribute(rotation2, 3)) 



 //particlesMaterial.map = particleTexture

//particle material
const particlesMaterial2 = new THREE.PointsMaterial()
particlesMaterial2.size = 0.6
particlesMaterial2.sizeAttenuation = true
//particlesMaterial2.color = new THREE.Color('#00ffff')
//particlesMaterial.map = particleTexture
particlesMaterial2.transparent = true
particlesMaterial2.alphaMap = particleTexture2
//particlesMaterial.alphaTest = 0.001
particlesMaterial2.depthWrite = false
particlesMaterial2.vertexColors = true



const particles2 = new THREE.Points(particlesGeometry2, particlesMaterial2)
scene.add(particles2)
//particles2.rotation.y= Math.random();
particles2.position.set(-8, 1, -15)
particles2.scale.set(18, 15, 20)

//Lights
const hemi = new THREE.HemisphereLight(0xffffbb, 0x080820, 2.5)
hemi.position.set(-1, 20, -1)
scene.add(hemi)

//IMAGE
// instantiate a loader
// const imageLoader = new THREE.TextureLoader()

// // Load an image file into a custom material
// const imageMaterial = new THREE.MeshLambertMaterial({
//     map: imageLoader.load('img/venicetwirl.jpg')
// })

// create a plane geometry for the image with a width of 10
// and a height that preserves the image's aspect ratio
// const imageGeometry = new THREE.PlaneGeometry(0, 0, 0)

// // combine our image geometry and material into a mesh
// const logo = new THREE.Mesh(imageGeometry, imageMaterial)
// logo.castShadow = true

// // set the position of the image mesh in the x,y,z dimensions
// logo.position.set(0, 1, 0)
// logo.rotation.set(0, 2.2, 0)
// logo.scale.set(1, 1, 1)
// //logo.transparent = true;

// // add the image to the scene
// scene.add(logo)

//Objects

// for (let i = 0; i < 100; i++) {
//     const sphereGeometry = new THREE.SphereGeometry(0.1, 0.1, 20, 45)
//     const sphereMaterial = new THREE.MeshMatcapMaterial({
//         matcap: matcapTexture2
//     })
//     const ball = new THREE.Mesh(sphereGeometry, sphereMaterial)

//     ball.position.x = (Math.random() - 0.2) * 15
//     ball.position.y = (Math.random() - 0.5) * 15
//     ball.position.z = (Math.random() - 0.1) * 15
//     ball.rotation.x = Math.random() * Math.PI
//     ball.rotation.y = Math.random() * Math.PI
//     scene.add(ball)
// }

//3D models

// model 1
var modelgltf1;
let mixer1 = null;

const loader = new GLTFLoader(loadingManager).setPath('models/')

loader.load(
  'venice3_ani.glb',
  function (gltf) { 
    modelgltf1 = gltf.scene;
    modelgltf1.position.x = -7
    modelgltf1.position.y = 0
    modelgltf1.position.z = -7.95
    modelgltf1.rotation.y = 2.029
    modelgltf1.scale.set(0.07, 0.07, 0.07)
    scene.add(modelgltf1)

    mixer1 = new THREE.AnimationMixer(modelgltf1)
    const action = mixer1.clipAction(gltf.animations[0])
    action.play()

    gui
.add(modelgltf1.rotation, 'y')
.min(- 40)
.max(40)
.step(0.001)
.name('Model1-y')
gui
.add(modelgltf1.position, 'z')
.min(- 40)
.max(40)
.step(0.01)
.name('Model1-Z')
gui
.add(modelgltf1.position, 'x')
.min(- 40)
.max(40)
.step(0.01)
.name('Model1-X')

  },
  
  undefined,
  function (error) {
    console.error(error)
  }
   
  
)

// model 2
var modelgltf2;
let mixer2 = null;
loader.load(
  'venice1_bright_ani.glb',
  function (gltf) {
    modelgltf2 = gltf.scene;
    gltf.scene.position.x = 8.5
    gltf.scene.position.y = 0
    gltf.scene.position.z = -15
    gltf.scene.rotation.y = 0.2
    gltf.scene.scale.set(0.1, 0.1, 0.1)
    scene.add(modelgltf2)

    mixer2 = new THREE.AnimationMixer(modelgltf2)
    const action = mixer2.clipAction(gltf.animations[0])
    action.play()


    gui
.add(modelgltf2.position, 'z')
.min(- 20)
.max(20)
.step(0.01)
.name('Model2-Z')
gui
.add(modelgltf2.position, 'x')
.min(- 20)
.max(20)
.step(0.01)
.name('Model2-X')
gui
.add(modelgltf2.rotation, 'y')
.min(- 2)
.max(4)
.step(0.01)
.name('Model2-Y')
  },
  undefined,
  function (error) {
    console.error(error)
  }
)

//model 3
var modelgltf3;
let mixer3 = null;

//const loader = new GLTFLoader(loadingManager).setPath('models/')

loader.load(
  'venice3_ani.glb',
  function (gltf) { 
    modelgltf3 = gltf.scene;
    gltf.scene.position.x = -0.57
    gltf.scene.position.y = 0
    gltf.scene.position.z = -35.95
    gltf.scene.rotation.y = -1.33
    gltf.scene.scale.set(0.07, 0.07, 0.07)
    scene.add(modelgltf3)

    mixer3 = new THREE.AnimationMixer(modelgltf3)
    const action = mixer3.clipAction(gltf.animations[0])
    action.play()

    gui
.add(modelgltf3.rotation, 'y')
.min(- 5)
.max(5)
.step(0.0001)
.name('Model3-y')
    gui
.add(modelgltf3.position, 'z')
.min(- 40)
.max(20)
.step(0.01)
.name('Model3-Z')
    gui
.add(modelgltf3.position, 'x')
.min(- 20)
.max(20)
.step(0.01)
.name('Model3-X')

  },
  
  undefined,
  function (error) {
    console.error(error)
  }
   
  
)

// model 4
var modelgltf4;
let mixer4 = null;
loader.load(
  'venice2_ani.glb',
  function (gltf) {
    modelgltf4 = gltf.scene;
    gltf.scene.position.x = -18.49
    gltf.scene.position.y = 0
    gltf.scene.position.z = -30.62
    gltf.scene.rotation.y = 1.91
    gltf.scene.scale.set(0.04, 0.04, 0.04)
    scene.add(modelgltf4)

    mixer4 = new THREE.AnimationMixer(modelgltf4)
    const action = mixer4.clipAction(gltf.animations[0])
    action.play()

    gui
.add(modelgltf4.rotation, 'y')
.min(- 5)
.max(5)
.step(0.0001)
.name('Model4-y')
    gui
.add(modelgltf4.position, 'z')
.min(- 40)
.max(40)
.step(0.01)
.name('Model4-Z')
    gui
.add(modelgltf4.position, 'x')
.min(- 40)
.max(40)
.step(0.01)
.name('Model4-X')
  },
  undefined,
  function (error) {
    console.error(error)
  }
)
// model 5
var modelgltf5;
loader.load(
  'venice4.glb',
  function (gltf) {
    modelgltf5 = gltf.scene;
    gltf.scene.position.x = 22
    gltf.scene.position.y = 1
    gltf.scene.position.z = -12.8
    gltf.scene.rotation.y = -1.3
    gltf.scene.scale.set(0.1, 0.1, 0.1)
    scene.add(modelgltf5)

    gui
.add(modelgltf5.position, 'z')
.min(- 60)
.max(20)
.step(0.001)
.name('Model5-Z')
gui
.add(modelgltf5.position, 'x')
.min(- 60)
.max(20)
.step(0.001)
.name('Model5-X')
gui
.add(modelgltf5.rotation, 'y')
.min(- 2)
.max(4)
.step(0.01)
.name('Model5-Y')
  },
  undefined,
  function (error) {
    console.error(error)
  }
)

//model 6

var modelgltf6;
loader.load(
  'venice1Test.glb',
  function (gltf) {
      modelgltf6 = gltf.scene;
    gltf.scene.position.x = 2.05
    gltf.scene.position.y = -0.1
    gltf.scene.position.z = -42.1
    gltf.scene.rotation.y = 3.5
    gltf.scene.scale.set(0.06, 0.06, 0.06)
    scene.add(modelgltf6)

    gui
.add(modelgltf6.position, 'z')
.min(- 60)
.max(20)
.step(0.001)
.name('Model6-Z')
gui
.add(modelgltf6.position, 'x')
.min(- 60)
.max(20)
.step(0.001)
.name('Model6-X')
gui
.add(modelgltf6.rotation, 'y')
.min(- 2)
.max(4)
.step(0.01)
.name('Model6-Y')
  },
  undefined,
  function (error) {
    console.error(error)
  }
)

//model 7

var modelgltf7;
loader.load(
  'CRW4-gnEVlODX.glb',
  function (gltf) {
      modelgltf7 = gltf.scene;
    gltf.scene.position.x = -0.6
    gltf.scene.position.y = 1
    gltf.scene.position.z = -51
    gltf.scene.rotation.y = -0.53
    gltf.scene.scale.set(0.1, 0.1, 0.1)
    scene.add(modelgltf7)

    gui
.add(modelgltf7.position, 'z')
.min(- 60)
.max(20)
.step(0.001)
.name('Model7-Z')
gui
.add(modelgltf7.position, 'x')
.min(- 60)
.max(20)
.step(0.001)
.name('Model7-X')
gui
.add(modelgltf7.rotation, 'y')
.min(- 2)
.max(4)
.step(0.01)
.name('Model7-Y')
  },
  undefined,
  function (error) {
    console.error(error)
  }
)

//model 8

var modelgltf8;
loader.load(
  'antenna_3.glb',
  function (gltf) {
      modelgltf8 = gltf.scene;
    gltf.scene.position.x = -9
    gltf.scene.position.y = 2
    gltf.scene.position.z = -5
    gltf.scene.rotation.y = -0.53
    gltf.scene.rotation.x = -0.53
    gltf.scene.scale.set(0.07, 0.07, 0.07)
    scene.add(modelgltf8)

    gui
.add(modelgltf8.position, 'z')
.min(- 60)
.max(20)
.step(0.001)
.name('Model8-Z')
gui
.add(modelgltf8.position, 'x')
.min(- 60)
.max(20)
.step(0.001)
.name('Model8-X')
gui
.add(modelgltf8.rotation, 'y')
.min(- 2)
.max(4)
.step(0.01)
.name('Model8-Y')
  },
  undefined,
  function (error) {
    console.error(error)
  }
)

var modelgltfHK;
loader.load(
    'HK_triangle_dump.glb',
    function (gltf) {
        modelgltfHK = gltf.scene;
      gltf.scene.position.x = -9.17
      gltf.scene.position.y = 11.2
      gltf.scene.position.z = -62
      
      gltf.scene.rotation.x = 0.72
      gltf.scene.rotation.y = -0.4
      gltf.scene.rotation.z= -0.25
      gltf.scene.scale.set(3.5, 3.5, 3.5)
      scene.add(modelgltfHK)

      gui
.add(modelgltfHK.rotation, 'y')
.min(- 5)
.max(5)
.step(0.0001)
.name('ModelHK-y')
gui
.add(modelgltfHK.rotation, 'x')
.min(- 5)
.max(5)
.step(0.0001)
.name('ModelHK-x')
gui
.add(modelgltfHK.rotation, 'z')
.min(- 5)
.max(5)
.step(0.0001)
.name('ModelHK-Z')
    gui
.add(modelgltfHK.position, 'z')
.min(- 75)
.max(40)
.step(0.01)
.name('ModelHK-Z')
    gui
.add(modelgltfHK.position, 'x')
.min(- 75)
.max(40)
.step(0.01)
.name('ModelHK-X')
gui
.add(modelgltfHK.position, 'y')
.min(- 75)
.max(40)
.step(0.01)
.name('ModelHK-Y')
    },
    undefined,
    function (error) {
      console.error(error)
    }
  )

// model b2
var modelgltfb2;
let mixerb2 = null;
loader.load(
  'venice2_ani_dual.glb',
  function (gltf) {
    modelgltfb2 = gltf.scene;
    gltf.scene.position.x = 11.55
    gltf.scene.position.y = 0
    gltf.scene.position.z = -3.72
    gltf.scene.rotation.y = 3.38
    gltf.scene.scale.set(-0.05, 0.05, 0.05)
    scene.add(modelgltfb2)

    mixerb2 = new THREE.AnimationMixer(modelgltfb2)
    const action = mixerb2.clipAction(gltf.animations[0])
    action.play()


    gui
.add(modelgltfb2.position, 'z')
.min(- 50)
.max(20)
.step(0.01)
.name('Model B1-Z')
gui
.add(modelgltfb2.position, 'x')
.min(- 20)
.max(20)
.step(0.01)
.name('Model B1-X')
gui
.add(modelgltfb2.rotation, 'y')
.min(- 2)
.max(4)
.step(0.01)
.name('Model B1-Y')
  },
  undefined,
  function (error) {
    console.error(error)
  }
)

// model b1
var modelgltfb1;
let mixerb1 = null;
loader.load(
  'venice1_bright_ani.glb',
  function (gltf) {
    modelgltfb1 = gltf.scene;
    gltf.scene.position.x = -20
    gltf.scene.position.y = 0
    gltf.scene.position.z = -43
    gltf.scene.rotation.y = -1.43
    gltf.scene.scale.set(0.1, 0.1, 0.1)
    scene.add(modelgltfb1)

    mixerb1 = new THREE.AnimationMixer(modelgltfb1)
    const action = mixerb1.clipAction(gltf.animations[0])
    action.play()


    gui
.add(modelgltfb1.position, 'z')
.min(- 50)
.max(20)
.step(0.01)
.name('Model B1-Z')
gui
.add(modelgltfb1.position, 'x')
.min(- 20)
.max(20)
.step(0.01)
.name('Model B1-X')
gui
.add(modelgltfb1.rotation, 'y')
.min(- 2)
.max(4)
.step(0.01)
.name('Model B1-Y')
  },
  undefined,
  function (error) {
    console.error(error)
  }
)

// model antenna
var modelgltfa;
let mixera = null;
loader.load(
  'antenna crawler_3_anim.glb',
  function (gltf) {
    modelgltfa = gltf.scene;
   
    gltf.scene.position.x = -3
    gltf.scene.position.y = 2.4
    gltf.scene.position.z = -26
    gltf.scene.rotation.y = 2
    gltf.scene.scale.set(0.1, 0.1, 0.1)
    scene.add(modelgltfa)

    mixera = new THREE.AnimationMixer(modelgltfa)
    const action = mixera.clipAction(gltf.animations[3])
    action.play()


    gui
.add(modelgltfa.position, 'z')
.min(- 50)
.max(20)
.step(0.01)
.name('Model B1-Z')
gui
.add(modelgltfa.position, 'x')
.min(- 20)
.max(20)
.step(0.01)
.name('Model B1-X')
gui
.add(modelgltfa.rotation, 'y')
.min(- 2)
.max(4)
.step(0.01)
.name('Model B1-Y')
  },
  undefined,
  function (error) {
    console.error(error)
  }
)

// model spin antenna
var modelgltfc;
let mixerc = null;
loader.load(
  'antenna2_spin.glb',
  function (gltf) {
    modelgltfc = gltf.scene;
   
    gltf.scene.position.x = -13
    gltf.scene.position.y = -0.5
    gltf.scene.position.z = -21
    gltf.scene.rotation.y = 1.5
    gltf.scene.rotation.x = 1.3
    gltf.scene.rotation.z = -2.7
    gltf.scene.scale.set(0.1, 0.1, 0.1)
    scene.add(modelgltfc)

    mixerc = new THREE.AnimationMixer(modelgltfc)
    const action = mixerc.clipAction(gltf.animations[0])
    action.play()


   
  },
  undefined,
  function (error) {
    console.error(error)
  }
)
// loader.load(
//   'venice4.glb',
//   function (gltf) {
//     gltf.scene.position.x = 2
//     gltf.scene.position.y = -0.1
//     gltf.scene.position.z = -4
//     gltf.scene.rotation.y = -0.7
//     gltf.scene.scale.set(0.1, 0.1, 0.1)
//     scene.add(gltf.scene)
//   },
//   undefined,
//   function (error) {
//     console.error(error)
//   }
// )


/**
 * Object
 */

//WATER

const water = buildWater()
function buildWater() {
    const waterGeometry = new THREE.PlaneGeometry(10000, 10000)
    const water = new Water(waterGeometry, {
        textureWidth: 512,
        textureHeight: 512,
        waterNormals: new THREE.TextureLoader().load(
            'textures/waternormals.jpg',
            function(texture) {
                texture.wrapS = texture.wrapT = THREE.RepeatWrapping
            }
        ),
        alpha: 1.0,
        //sunDirection: new THREE.Vector3(),
        // sunColor: 0xffffff,
        waterColor: 0x001e0f,
        distortionScale: 3,
        fog: scene.fog !== undefined
    })
    water.rotation.x = -Math.PI / 2
    scene.add(water)

    const waterUniforms = water.material.uniforms
    return water
}

//Floor
//const floorPlane = new THREE.PlaneGeometry(200, 200, 8, 8)
//const planeTexture = new THREE.MeshMatcapMaterial({ matcap: matcapTexture3 })
//const floor = new THREE.Mesh(floorPlane, planeTexture)
//floorPlane.receiveShadow = true;
//scene.add(floor)
//floorPlane.rotateX( - Math.PI / 2);

//Text
const fontLoader = new THREE.FontLoader()
fontLoader.load('fonts/helvetiker_bold.typeface.json', font => {
    const textGeometry = new THREE.TextGeometry('', {
        font: font,
        size: 0.7,
        height: 0.2,
        curveSegments: 12,
        bevelEnabled: true,
        bevelThickness: 0.03,
        bevelSize: 0.02,
        bevelOffset: 0,
        bevelSegments: 5
    })

    const textGeometry3 = new THREE.TextGeometry('Cities', {
        font: font,
        size: 0.75,
        height: 0.2,
        curveSegments: 12,
        bevelEnabled: true,
        bevelThickness: 0.03,
        bevelSize: 0.02,
        bevelOffset: 0,
        bevelSegments: 5
    })
    const textMaterial = new THREE.MeshMatcapMaterial({ matcap: matcapTexture })
    textMaterial.wireframe = false
    const text = new THREE.Mesh(textGeometry, textMaterial)

    const text3 = new THREE.Mesh(textGeometry3, textMaterial)

    scene.add(text, text3)
    text.position.x = -3.1
    text.position.y = 1.7
    text.position.z = 4.7
    text.rotation.y = -5.3
    text.castShadow = true //default is false
    text.receiveShadow = true

    text3.position.x = -3.5
    text3.position.y = 0.025
    text3.position.z = 5
    text3.rotation.y = -5.4
    text3.castShadow = true //default is false
    text3.receiveShadow = true
})

fontLoader.load('fonts/helvetiker_regular.typeface.json', font => {
    const textGeometry2 = new THREE.TextGeometry('Invisible', {
        font: font,
        size: 0.75,
        height: 0.3,
        curveSegments: 12,
        bevelEnabled: true,
        bevelThickness: 0.03,
        bevelSize: 0.02,
        bevelOffset: 0,
        bevelSegments: 5
    })

    const textMaterial2 = new THREE.MeshMatcapMaterial({
        matcap: matcapTexture2
    })
    textMaterial2.wireframe = true
    const text2 = new THREE.Mesh(textGeometry2, textMaterial2)

    textGeometry2.center()

    text2.position.set(-3.2, 1.2, 4.8)
    text2.rotation.y = -5.3
    text2.castShadow = true //default is false
    text2.receiveShadow = true
    scene.add(text2)
})

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera, angle of fov in rads, aspectRatio, near,far
const camera = new THREE.PerspectiveCamera(
    60,
    sizes.width / sizes.height,
    0.1,
    2000
)
camera.position.x = -4
camera.position.z = -7
camera.position.y = 0.6
//camera.position.z = 5;

scene.add(camera)

// // Controls
// const controls = new OrbitControls(camera, canvas)
// controls.target.set(0, 1.5, 5)
// controls.rotateSpeed *= -1
// controls.enableDamping = true

// PointerLockcontrols
const controls = new PointerLockControls(camera, canvas)

controls.addEventListener('lock', () => {
    menu.style.display = 'none' // hide the menu
    //window.location.reload()
    
})

controls.addEventListener('unlock', () => {
    menu.style.display = 'block'
    videoE2.pause()
    videoEl1.pause()
    videoE3.pause()
    positionalAudio1.pause()
    positionalAudio2.pause()
    positionalAudio3.pause()
})

startBtn.addEventListener(
    'click',
    () => {
        
        controls.lock() // emits 'lock' event
        videoE2.play() // play the video for the first time
        videoE3.play()
        videoEl1.play()
        positionalAudio1.play()
        positionalAudio2.play()
        positionalAudio3.play()
        //loadPositionalAudio() // load audio only when pointer is locked'
    },
    false
)

function onKeyDown(event) {
    switch (event.code) {
    case 'ArrowUp':
    case 'KeyW':
        moveForward = true
        break
    case 'ArrowLeft':
    case 'KeyA':
        moveLeft = true
        break
    case 'ArrowDown':
    case 'KeyS':
        moveBack = true
        break
    case 'ArrowRight':
    case 'KeyD':
        moveRight = true
        break
    default:
        break
    }
}

function onKeyUp(event) {
    switch (event.code) {
    case 'ArrowUp':
    case 'KeyW':
        moveForward = false
        break
    case 'ArrowLeft':
    case 'KeyA':
        moveLeft = false
        break
    case 'ArrowDown':
    case 'KeyS':
        moveBack = false
        break
    case 'ArrowRight':
    case 'KeyD':
        moveRight = false
        break
    default:
        break
    }
}

document.addEventListener('keydown', onKeyDown, false)
document.addEventListener('keyup', onKeyUp, false)

//FIRST VIDEO -- Audio and PositionalAudio logic
const audioLoader1 = new THREE.AudioLoader()

const listener1 = new THREE.AudioListener()
// listener.position(-4, 0.6, -7)
camera.add(listener1)

const audioUrl1 = 'video/3third_audio_Blind.mp3'
const videoUrl1 = 'video/3third_mute_Blind.mp4'

let videoScreen1 = new THREE.Object3D()

let videoEl1 = document.createElement('video')
// videoEl.controls = false
videoEl1.src = videoUrl1
videoEl1.load()
videoEl1.muted = true
videoEl1.loop = true
videoEl1.autoplay = true

const positionalAudio1 = new THREE.PositionalAudio(listener1)

audioLoader1.load(audioUrl1, function(buffer) {
    positionalAudio1.setDirectionalCone(90, 120, 0.0001)
    positionalAudio1.setRefDistance(1)
    //positionalAudio.setMaxDistance(20)
    positionalAudio1.setBuffer(buffer)
    positionalAudio1.loop = true
    positionalAudio1.play()
    positionalAudio1.position.y = 0.1
    positionalAudio1.position.z = 2.5
    //positionalAudio.rotation.z = 2.5

    // const soundHelper1 = new PositionalAudioHelper(positionalAudio1)
    // soundHelper1.scale.set(2, 2, 2)
    // positionalAudio1.add(soundHelper)

    videoEl1.play()
    console.log(positionalAudio1.getDistanceModel(linear))
})

let videoTexture1 = new THREE.VideoTexture(videoEl1)
videoTexture1.minFilter = THREE.LinearFilter
videoTexture1.magFilter = THREE.LinearFilter
videoTexture1.format = THREE.RGBFormat

let planeMesh1 = new THREE.Mesh(
    new THREE.PlaneGeometry(1.5, 1.5, 2, 2),
    new THREE.MeshBasicMaterial({
        map: videoTexture1,
        side: THREE.DoubleSide
    })
)

videoScreen1.add(planeMesh1)
videoScreen1.add(positionalAudio1)

videoScreen1.position.x = 10;
videoScreen1.position.z = -9.5;
videoScreen1.rotation.y = 4.9;
videoEl1.onloadeddata = function() {
    console.log('video data loaded')
    const aspectRatio1 = videoEl1.videoWidth / videoEl1.videoHeight
    planeMesh1.scale.set(1.5 * aspectRatio1, 1.5, 0)
    planeMesh1.position.y = 1.5;
}
scene.add(videoScreen1)



// SECOND VID -- Audio and PositionalAudio logic
const audioLoader2 = new THREE.AudioLoader()

const listener2 = new THREE.AudioListener()
    // listener.position(-4, 0.6, -7)
camera.add(listener2)

const audioUrl2 = 'video/2third_audio_Blind.mp3'
const videoUrl2 = 'video/2third_mute_blind.mp4'

let videoScreen2 = new THREE.Object3D()

let videoE2 = document.createElement('video')
// videoEl.controls = false
videoE2.src = videoUrl2
videoE2.load()
videoE2.muted = true
videoE2.loop = true
videoE2.autoplay = true

const positionalAudio2 = new THREE.PositionalAudio(listener2)

audioLoader2.load(audioUrl2, function(buffer) {
    positionalAudio2.setDirectionalCone(100, 180, 0.000001)
    positionalAudio2.setRefDistance(1)
    //positionalAudio.setMaxDistance(20)
    positionalAudio2.setBuffer(buffer)
    positionalAudio2.loop = true
    positionalAudio2.play()
    positionalAudio2.position.x = -0.2
    positionalAudio2.position.y = 0.1
    positionalAudio2.position.z = 2
    positionalAudio2.rotation.y = -0.3
    //positionalAudio.rotation.z = 2.5

    // const soundHelper2 = new PositionalAudioHelper(positionalAudio2)
    // soundHelper2.scale.set(2, 2, 2)
    // positionalAudio2.add(soundHelper2)

    videoE2.play()
    console.log(positionalAudio2.getDistanceModel(linear))
})

let videoTexture2 = new THREE.VideoTexture(videoE2)
videoTexture2.minFilter = THREE.LinearFilter
videoTexture2.magFilter = THREE.LinearFilter
videoTexture2.format = THREE.RGBFormat

let planeMesh2 = new THREE.Mesh(
    new THREE.PlaneGeometry(1.5, 1.5, 2, 2),
    new THREE.MeshBasicMaterial({
        map: videoTexture2,
        side: THREE.DoubleSide
    })
)

videoScreen2.add(planeMesh2)
videoScreen2.add(positionalAudio2)

videoScreen2.position.x = -16;
videoScreen2.position.z = -34;
videoScreen2.rotation.y = 1.8;
videoE2.onloadeddata = function() {
    console.log('video data loaded')
    const aspectRatio2 = videoE2.videoWidth / videoE2.videoHeight
    planeMesh2.scale.set(2 * aspectRatio2, 2, 1)
    planeMesh2.position.y = 1.5;
}
scene.add(videoScreen2);



// THIRD VID -- Audio and PositionalAudio logic
const audioLoader3 = new THREE.AudioLoader()

const listener3 = new THREE.AudioListener()
    // listener.position(-4, 0.6, -7)
camera.add(listener3)

const audioUrl3 = 'video/1third_audio_Blind.mp3'
const videoUrl3 = 'video/1third_mute_Blind.mp4'

let videoScreen3 = new THREE.Object3D()

let videoE3 = document.createElement('video')
// videoEl.controls = false
videoE3.src = videoUrl3
videoE3.load()
videoE3.muted = true
videoE3.loop = true
videoE3.autoplay = true

const positionalAudio3 = new THREE.PositionalAudio(listener3)

audioLoader3.load(audioUrl3, function(buffer) {
    positionalAudio3.setDirectionalCone(100, 180, 0.000001)
    positionalAudio3.setRefDistance(1)
    //positionalAudio.setMaxDistance(20)
    positionalAudio3.setBuffer(buffer)
    positionalAudio3.loop = true
    positionalAudio3.play()
    positionalAudio3.position.x = -0.2
    positionalAudio3.position.y = 0.1
    positionalAudio3.position.z = 2
    positionalAudio3.rotation.y = -0.3
    //positionalAudio.rotation.z = 2.5

    // const soundHelper3 = new PositionalAudioHelper(positionalAudio3)
    // soundHelper3.scale.set(2, 2, 2)
    // positionalAudio3.add(soundHelper3)

    videoE3.play()
    console.log(positionalAudio3.getDistanceModel(linear))
})

let videoTexture3 = new THREE.VideoTexture(videoE3)
videoTexture3.minFilter = THREE.LinearFilter
videoTexture3.magFilter = THREE.LinearFilter
videoTexture3.format = THREE.RGBFormat

let planeMesh3 = new THREE.Mesh(
    new THREE.PlaneGeometry(1.5, 1.5, 2, 2),
    new THREE.MeshBasicMaterial({
        map: videoTexture3,
        side: THREE.DoubleSide
    })
)

videoScreen3.add(planeMesh3)
videoScreen3.add(positionalAudio3)

videoScreen3.position.x = 5;
videoScreen3.position.z = -50.5;
videoScreen3.rotation.y = -1.4;
videoE3.onloadeddata = function() {
    console.log('video data loaded')
    const aspectRatio3 = videoE3.videoWidth / videoE3.videoHeight;
    planeMesh3.scale.set(3 * aspectRatio3, 3, 0)
    planeMesh3.position.y = 1.5;
}

scene.add(videoScreen3)

const clock = new THREE.Clock()

// simulate a timestamp difference(time-prevTime), used together with calcDelta to calculate delta
function randInt(min, max) {
    return Math.floor(Math.random() * (max - min) + min)
}

function calcDelta(x) {
    return x / 1000
}

// handles pointer movement once cursor is 'locked'
const pointerCtrl = () => {
    if (controls.isLocked) {
        const delta = calcDelta(randInt(26, 36))
        direction.x = Number(moveRight) - Number(moveLeft)
        direction.z = Number(moveForward) - Number(moveBack)
        direction.normalize()
        velocity.x = direction.x * 2 * delta
        velocity.z = direction.z * 2 * delta

        controls.moveForward(velocity.z)
        controls.moveRight(velocity.x)
    }
}

const tick = () => {
    pointerCtrl()
    const elapsedTime = clock.getElapsedTime()
    //const deltaTime = clock.getDeltaTime()

    //Animate Venice twirl?
    // logo.position.x = 2.5 + Math.cos(elapsedTime) * 1
    // logo.position.y = 2.5 + Math.sin(elapsedTime) * 0.5

    // logo.position.x = 2.5 + Math.cos(elapsedTime) * 0.3
    // logo.position.y = 2.5 + Math.sin(elapsedTime) * 0.5
    //video move
    // videoplane.position.x = -13 + Math.cos(elapsedTime) * 1
    // videoplane.position.z = -35.5 + Math.sin(elapsedTime) * 0.5
    // videoplane.position.y += 0.0001

    // videoplane.rotation.x = 0 + Math.cos(elapsedTime) * 0.2
    // videoplane.rotation.y = 0.18
        // VID1
    videoScreen1.position.x = 10 + Math.cos(elapsedTime) * 0.1
    videoScreen1.position.z = -9.5 + Math.sin(elapsedTime) * 0.1
    videoScreen1.position.y += 0.0001
    videoScreen1.rotation.x = 0 + Math.cos(elapsedTime) * 0.05
        // VID 2
    videoScreen2.position.x = -16 + Math.cos(elapsedTime) * 0.1
    videoScreen2.position.z = -34 + Math.sin(elapsedTime) * 0.1
    videoScreen2.position.y += 0.0001
    videoScreen2.rotation.x = 0 + Math.cos(elapsedTime) * 0.05

     // VID 3
     videoScreen3.position.x = 5 + Math.cos(elapsedTime) * 0.1
     videoScreen3.position.z = -49.5 + Math.sin(elapsedTime) * 0.1
     videoScreen3.position.y += 0.0001
     videoScreen3.rotation.x = 0 + Math.cos(elapsedTime) * 0.05
    //videoScreen.rotation.y = 0.18
    //particles move

    particles1.rotation.y += 0.001
    particles1.position.y += -0.001

    particles2.rotation.z += -0.001
    particles2.position.x += 0.001

   // modelgltfc.position.y += 0.001;

    //animate model?
    if (mixer1) {
        mixer1.update(0.002 * Math.sin(elapsedTime))
    }
    if (mixer2) {
        mixer2.update(0.01 * Math.cos(elapsedTime))
    }
    if (mixer3) {
        mixer3.update(0.0005 * Math.sin(elapsedTime))
    }
    if (mixer4) {
        mixer4.update(0.01 * Math.cos(elapsedTime))
    }
    if (mixerb1) {
        mixerb1.update(0.01 * Math.cos(elapsedTime))
    }
    if (mixerb2) {
        mixerb2.update(0.01 * Math.cos(elapsedTime))
    }
    if(mixera)
    {
        mixera.update(Math.cos(-elapsedTime*0.00005)* (elapsedTime*0.00005));
    }
    if(mixerc)
    {
        mixerc.update(0.1 * Math.cos(elapsedTime));
    }

    //modelgltf1.position.x = 0 + Math.cos(elapsedTime) * 1;

    //animate water
    water.material.uniforms['time'].value += 1.0 / 240.0
    const time = performance.now() * 0.001
    water.position.y += 0.0001
    camera.position.y += 0.0001
    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()
